<div
  class="messages-chats-content-action"
  (click)="onClick()"
  (mouseenter)="mouseOn = true"
  (mouseleave)="mouseOn = false"
  touchLongPress
  [duration]="500"
  (longPress)="touchLongPress()"
  (contextmenu)="$event.preventDefault(); openMenu = true"
>
  <div
    *ngIf="chat.type === chatTypeRoomMessage"
    class="message-author-photo-container"
  >
    <span class="material-icons icon-business"> business </span>
  </div>

  <img
    *ngIf="chat.type === chatTypeUserMessage"
    class="message-user-photo"
    [src]="chat.message.user.photo"
  />

  <div class="messages-chats">
    <div class="message-title-and-hour-container">
      <div class="message-title">
        <div
          class="message-room-title"
          *ngIf="chat.type === chatTypeRoomMessage"
        >
          {{ chat.message.name }}
        </div>
        <div class="message-author-title">
          {{
            chat.type === chatTypeRoomMessage
              ? chat.message.alias
              : chat.message.user.fullname
          }}
        </div>
      </div>
      <div
        class="message-hour"
        [ngClass]="chat.message.numMessagesUnread ? 'message-hour-unread' : ''"
        *ngIf="chat.message.lastMessage"
      >
        {{
          isToday(chat.message.lastMessage.dtMessage)
            ? (chat.message.lastMessage.dtMessage | date : "HH:mm")
            : (chat.message.lastMessage.dtMessage | date : "dd/MM/yyyy")
        }}
        <app-chat-item-menu
          [isVisible]="mouseOn"
          [(openMenu)]="openMenu"
          [chat]="chat"
          (chatChange)="onChatChange($event)"
        ></app-chat-item-menu>
      </div>
    </div>
    <div class="last-message-and-unread-container">
      <div class="last-message" *ngIf="chat.message.totalMessages > 0">
        <div *ngIf="chat.message.lastMessage.active; else messageDeleted">
          {{ (chat.message.lastMessage.text | slice : 0 : 32) + " .." }}
        </div>
        <ng-template #messageDeleted>
          <app-chat-removed-message
            [isAuthorMessage]="chat.message.lastMessage.idAuthor == idUser"
          >
          </app-chat-removed-message>
        </ng-template>
      </div>
      <div class="num-unread" *ngIf="this.chat.message.unread">
        <span
          *ngIf="
            this.chat.message.numMessagesUnread &&
            this.chat.message.numMessagesUnread > 0
          "
          >{{ this.chat.message.numMessagesUnread }}</span
        >
      </div>
    </div>
  </div>
</div>
